export default __webpack_public_path__ + "static/media/icono-instagram.3ed7a2fe.svg";